import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { ReactComponent as RectIcon } from "../img/rectangle-2.svg";
import { ReactComponent as RectIconStar } from "../img/rectangle_star.svg";
import { ReactComponent as RectIconArchive } from "../img/rectangle-3-archive.svg";

import { ReactComponent as HomeSvg } from "../img/home.svg";

import AssetIcon from "@mui/icons-material/Tag";

import ErrorIcon from "@mui/icons-material/Error";

import { ReactComponent as ProjectGenericSvg } from "../img/projectGeneric.svg";
import { ReactComponent as projectGenericLinkedSvg } from "../img/projectGeneric_v02_Linked.svg";

import { ReactComponent as TimelineSvg } from "../img/timeline.svg";
import { ReactComponent as projectUnrealEditSvg } from "../img/projectUnrealEdit_v02.svg";
import { ReactComponent as projectUnrealEditLinkedSvg } from "../img/projectUnrealEdit_v02_Linked.svg";
import { ReactComponent as assetShotSvg } from "../img/assetShot.svg";
import { ReactComponent as ProjectUnrealAssetIconSvg } from "../img/projectUnrealasset.svg";
import { ReactComponent as ProjectUnrealAssetIconLinkedSvg } from "../img/projectUnrealassetLinked.svg";
import { ReactComponent as LogoSvg } from "../img/logoWhite.svg";
import { ReactComponent as UnrealEngineLogo } from "../img/ue_logo.svg";

// icons/metadata
import { ReactComponent as SamplesSpatial } from "../img/icons/metadata/samples-spatial.svg";
import { ReactComponent as SamplesTemporal } from "../img/icons/metadata/samples-temporal.svg";
import { ReactComponent as ROIData } from "../img/icons/metadata/roi-data.svg";
import { ReactComponent as ROIDisplay } from "../img/icons/metadata/roi-display.svg";
import { ReactComponent as ColorSpace } from "../img/icons/metadata/colorspace.svg";
import { ReactComponent as Stopwatch } from "../img/icons/metadata/stopwatch.svg";
import { ReactComponent as ShutterAngle } from "../img/icons/metadata/shutter-angle.svg";

//icons/player-buttons
import { ReactComponent as MetaDataButton } from "../img/icons/player-buttons/metadata.svg";

import ProjectUnrealSceneIcon from "@mui/icons-material/PhotoCameraBack";

import { ReactComponent as FilmSvg } from "../img/film.svg";
import { ReactComponent as ImageSvg } from "../img/image.svg";

import { AssetType, ProjectType } from "../Types/types";

const JobIcon = (props: SvgIconProps) => {
	return <SvgIcon component={RectIcon} viewBox="0 0 700 700" {...props} />;
};

const JobIconStar = (props: SvgIconProps) => {
	return <SvgIcon component={RectIconStar} viewBox="0 0 700 700" {...props} />;
};

const JobIconArchive = (props: SvgIconProps) => {
	return <SvgIcon component={RectIconArchive} viewBox="0 0 700 700" {...props} />;
};

const HomeIcon = (props: SvgIconProps) => {
	return <SvgIcon component={HomeSvg} viewBox="0 0 24 24" {...props} />;
};

// const TopologyIcon = (props: SvgIconProps) => {
//   return <SvgIcon component={CreditCard} viewBox="0 0 24 24" {...props} />;
// };
const ProjectUnrealEditIcon = (props: SvgIconProps) => {
	return <SvgIcon component={projectUnrealEditSvg} viewBox="0 0 24 24" {...props} />;
};
const LogoIcon = (props: SvgIconProps) => {
	return <SvgIcon component={LogoSvg} viewBox="0 0 24 24" {...props} />;
};

const UnrealEngineLogoIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={UnrealEngineLogo} viewBox="0 0 24 24" ref={ref} {...props} />);

const ProjectUnrealAssetIcon = (props: SvgIconProps) => {
	return <SvgIcon component={ProjectUnrealAssetIconSvg} viewBox="0 0 24 24" {...props} />;
};

const ProjectUnrealAssetLinkedIcon = (props: SvgIconProps) => {
	return <SvgIcon component={ProjectUnrealAssetIconLinkedSvg} viewBox="0 0 24 24" {...props} />;
};

const ProjectUnrealEditLinkedIcon = (props: SvgIconProps) => {
	return <SvgIcon component={projectUnrealEditLinkedSvg} viewBox="0 0 24 24" {...props} />;
};

const ProjectGenericIcon = (props: SvgIconProps) => {
	return <SvgIcon component={ProjectGenericSvg} viewBox="0 0 24 24" {...props} />;
};

const ProjectGenericLinkedIcon = (props: SvgIconProps) => {
	return <SvgIcon component={projectGenericLinkedSvg} viewBox="0 0 24 24" {...props} />;
};

const AssetTimelineIcon = (props: SvgIconProps) => {
	return <SvgIcon component={TimelineSvg} viewBox="0 0 24 24" {...props} />;
};

const AssetShotIcon = (props: SvgIconProps) => {
	return <SvgIcon component={assetShotSvg} viewBox="0 0 24 24" {...props} />;
};

const FilmIcon = (props: SvgIconProps) => {
	return <SvgIcon component={FilmSvg} viewBox="0 0 24 24" {...props} />;
};
const ImageIcon = (props: SvgIconProps) => {
	return <SvgIcon component={ImageSvg} viewBox="0 0 24 24" {...props} />;
};

const TopologyIcon = (props: SvgIconProps) => (
	<svg width="24pt" height="24pt" viewBox="0 -3 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="white" {...props}>
		<g>
			<path d="m7.537 5.288c-2.382 0 -4.312 1.931 -4.312 4.312s1.931 4.312 4.312 4.312 4.312 -1.931 4.312 -4.312 -1.931 -4.312 -4.312 -4.312zm-0.409 6.156c-0.115 0.131 -0.438 0.292 -0.728 0.025l-1.29 -1.165 0.702 -0.778 0.914 0.826 2.509 -2.596 0.753 0.728z" />
			<path d="m20.212 11.55h-4.125c-0.311 0 -0.562 -0.252 -0.562 -0.562v-2.775c0 -0.311 0.252 -0.562 0.562 -0.562h4.125c0.311 0 0.562 0.252 0.562 0.562v2.775c0 0.311 -0.252 0.562 -0.562 0.562zm-3.563 -1.125h3v-1.65h-3z" />
			<path d="m11.55 9.037h4.537v1.125h-4.537z" />
			<path d="m14.7 2.588h4.125v2.775h-4.125z" />
			<path d="m18.825 5.925h-4.125c-0.311 0 -0.562 -0.252 -0.562 -0.562v-2.775c0 -0.311 0.252 -0.562 0.562 -0.562h4.125c0.311 0 0.562 0.252 0.562 0.562v2.775c0 0.311 -0.252 0.562 -0.562 0.562zm-3.563 -1.125h3v-1.65h-3z" />
			<path d="m12.15 3.412h1.088v1.125h-1.088z" />
			<path d="m8.112 4.875h-1.125v-0.9c0 -0.311 0.252 -0.562 0.562 -0.562h3.662v1.125h-3.1z" />
			<path d="m14.7 13.837h4.125v2.775h-4.125z" />
			<path d="m18.825 17.175h-4.125c-0.311 0 -0.562 -0.252 -0.562 -0.562v-2.775c0 -0.311 0.252 -0.562 0.562 -0.562h4.125c0.311 0 0.562 0.252 0.562 0.562v2.775c0 0.311 -0.252 0.562 -0.562 0.562zm-3.563 -1.125h3v-1.65h-3z" />
			<path d="m12.15 14.7h1.088v1.125h-1.088z" />
			<path d="m11.212 15.825h-3.662c-0.311 0 -0.562 -0.252 -0.562 -0.562v-0.938h1.125v0.375h3.1z" />
		</g>
	</svg>
);

const labelIconByAssetType = (assetType: AssetType) => {
	//type AssetType = "timeline" | "shot" | "prop" | "character" | "fx" | "environment" | "generic" | "generic_render";
	switch (assetType) {
		case "timeline":
			return AssetTimelineIcon;
		case "shot":
			return AssetShotIcon;
		case "prop":
			return AssetIcon;
		case "character":
			return AssetIcon;
		case "fx":
			return AssetIcon;
		case "environment":
			return AssetIcon;
		case "generic":
			return AssetIcon;
		case "generic_render":
			return AssetIcon;
	}
	//fallback
	return AssetIcon;
};

const labelIconByProjectType = (projectType: ProjectType, linked: boolean = false) => {
	//type ProjectType = "unrealasset" | "unrealedit" | "unrealscene" | "generic";
	switch (projectType) {
		case "unrealasset":
			return linked ? ProjectUnrealAssetLinkedIcon : ProjectUnrealAssetIcon;
		case "unrealedit":
			return linked ? ProjectUnrealEditLinkedIcon : ProjectUnrealEditIcon;
		case "unrealscene":
			return ProjectUnrealSceneIcon;
		case "generic":
			return linked ? ProjectGenericLinkedIcon : ProjectGenericIcon;
	}
	//fallback
	return ProjectGenericIcon;
};

const SamplesSpatialIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={SamplesSpatial} viewBox="0 0 24 24" ref={ref} {...props} />);
const SamplesTemporalIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={SamplesTemporal} viewBox="0 0 24 24" ref={ref} {...props} />);

const ROIDataIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={ROIData} viewBox="0 0 24 24" ref={ref} {...props} />);
const ROIDisplayIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={ROIDisplay} viewBox="0 0 24 24" ref={ref} {...props} />);
const ColorSpaceIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={ColorSpace} viewBox="0 0 24 24" ref={ref} {...props} />);
const StopwatchIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={Stopwatch} viewBox="0 0 24 24" ref={ref} {...props} />);
const ShutterAngleIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={ShutterAngle} viewBox="0 0 24 24" ref={ref} {...props} />);
const MetaDataButtonIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SvgIcon component={MetaDataButton} viewBox="0 0 24 24" ref={ref} {...props} />);

export {
	JobIcon,
	JobIconStar,
	JobIconArchive,
	ProjectUnrealEditIcon,
	ProjectUnrealAssetIcon,
	ProjectGenericIcon,
	HomeIcon,
	AssetIcon,
	ProjectUnrealSceneIcon,
	TopologyIcon,
	ErrorIcon,
	AssetTimelineIcon,
	AssetShotIcon,
	labelIconByAssetType,
	labelIconByProjectType,
	FilmIcon,
	ImageIcon,
	LogoIcon,
	UnrealEngineLogoIcon,
	// Metadata Icons
	SamplesSpatialIcon,
	SamplesTemporalIcon,
	ROIDataIcon,
	ROIDisplayIcon,
	ColorSpaceIcon,
	MetaDataButtonIcon,
	StopwatchIcon,
	ShutterAngleIcon,
};
